import styled from 'styled-components'

export const Point = styled.div`
  background: ${(props) => props.theme.common.pointBgColor};
  border-radius: 5px;
  width: 10px;
  height: 10px;
  margin: auto;
`
